/* =================== CRIA PAGAMENTO =================== */
jQuery(document).ready(function() {
  $(".btn-add-plano").on("click", function(e) {
    e.preventDefault();
    var idPlano = $(this).data("plano");
    var dados = {
      plano: idPlano
    };
    $.ajax({
      url: url_base + "acoes/app/corretor/grava_pedido.php",
      type: "POST",
      data: dados,
      beforeSend: function() {
        showLoading();
      },
      success: function(data) {
        console.log(data);
        data = $.parseJSON(data);
        if (data.status == "ok") {
          location.href = data.retorno;
        } else {
          hideLoading();
          showAlert(
            "Erro",
            "Não foi possível realizar esta operação.",
            "error"
          );
        }
      },
      error: function(xhr, type, exception) {
        hideLoading();
        showAlert("Erro", "Não foi possível realizar esta operação.", "error");
        console.log("ajax error response type " + type);
      }
    });
  });

  // Grava o pagamento
  $(".bt-registrar-pagamento").on("click", function(e) {

    let validado = false;
    hahsCartao();
    if($("#cartao_valido").val() == 'true'){
      validado = true;
    }else{
      validado = false;
    }

    if (validado) {
      e.preventDefault();
      if ($("#form-pagamento").parsley().validate()) {
        var dados = $("#form-pagamento").serialize();
        $.ajax({
          type: "POST",
          url: url_base + "acoes/app/pagamentos/grava_pagamento.php?acao=insert",
          data: dados,
          beforeSend: function() {
            showLoading();
          },
          success: function(data) {
            console.log(data);
            data = $.parseJSON(data);
            hideLoading();
            if (data.status_pagamento != 14) {
              location.href = url_base + "corretor/confirmacao/" + data.hash;
            } else {
              showAlert(
                "Erro",
                "Não foi possível completar o pagamento. Por favor, revise os dados e tente novamente.",
                "error"
              );
            }
          },
          error: function(xhr, type, exception, data) {
            hideLoading();
            console.log(data);
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        });
      }
    } else {
      e.preventDefault();
      showAlert(
        "Erro",
        "Revise os dados do cartão de crédito.",
        "error"
      );
    }

  });
});
